import React from 'react';
import { useHistory } from 'react-router-dom'; 
import { Box, Button, Typography } from '@mui/material';

function Page1() {
  const history = useHistory(); 

  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/a')}
                    >
                        Popular
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/b')}
                    >
                        Following
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c')}
                    >
                        Academia
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/d')}
                    >
                        Topic Threads
                    </Button>
                    {/*<Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/e')}
                    >
                        Recommended
                    </Button>*/}
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/photos')}
                    >
                        Photos
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos')}
                    >
                        Videos
                    </Button>
                    {/*<Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos')}
                    >
                        Omniverse
                    </Button>*/}
             </Box>
          </div>
  
 
    //<Box p={4}>
    /*
    <Box sx={{ backgroundColor: '#FFFDF8', minHeight: '100vh', p: 4 }}>
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button variant="contained" onClick={() => history.push('/page1/a')}>
          Popular
        </Button>
        <Button variant="contained" onClick={() => history.push('/page1/b')}>
          Following
        </Button>
        <Button variant="contained" onClick={() => history.push('/page1/c')}>
          Academia
        </Button>
        <Button variant="contained" onClick={() => history.push('/page1/d')}>
          Topic Threads
        </Button>
        <Button variant="contained" onClick={() => history.push('/page1/e')}>
          Recommended
        </Button>
      </Box>
    </Box>
    */
  );
}

export default Page1;
